import { compose, path, toPairs } from "ramda";
import { createSelector } from "reselect";
import * as model from "./utils";

export const scopeSelector = state => state.modules.user.onboarding;

export const getWizardApi = compose(path(["api", "getWizard"]), scopeSelector);

export const updateWizardApi = compose(
  path(["api", "updateWizard"]),
  scopeSelector
);

export const completedOnboarding = createSelector(
  getWizardApi,
  ({ data }) => data && data.completed_steps !== 0
);

export const getStep = createSelector(
  getWizardApi,
  ({ data }) => data && data.user_steps[0].step
);

export const getQuestions = createSelector(
  getWizardApi,
  ({ data }) =>
    data &&
    data.user_steps[0].step_data.map(({ id, must_be_filled, formfield }) => ({
      id:
        (formfield.field_type === "FILE" ? "file_field_" : "value_field_") +
        id.toString(),
      isRequired: must_be_filled,
      type: formfield.field_type,
      label: formfield.label,
      choices: formfield.list_choices && toPairs(formfield.list_choices)
    }))
);

export const getInitialValues = createSelector(
  [getQuestions],
  questions => questions && model.getInitialValues(questions)
);

export const getValidationSchema = createSelector(
  [getQuestions],
  questions => questions && model.getValidationSchema(questions)
);

export const claimDiscountApi = compose(
  path(["api", "claimDiscount"]),
  scopeSelector
);
export const claimDiscount = createSelector(
  [claimDiscountApi],
  api => api.data
);

export const insiderOnboardingApi = compose(
  path(["api", "insiderOnboarding"]),
  scopeSelector
);



// WEBPACK FOOTER //
// ./src/modules/user/onboarding/selectors.js